// extracted by mini-css-extract-plugin
export default {"content":"Profile_content__-TELE","card_header":"Profile_card_header__iynyd","card_myRecipe":"Profile_card_myRecipe__gdlMi","hide_file":"Profile_hide_file__iA2+j"};